import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import './styles.css';
import Avatar from '../../../../components/Avatar';
import LinkCandidateProfile from '../../../../components/LinkCandidateProfile';
import LoadMask from '../../../../components/LoadMask';
import ENDPOINT from '../../../../constants/endpoints';
import ROUTE from '../../../../constants/route';
import LinkBuilder from '../../../../helpers/link-builder';
import {useGrid} from '../../../../hooks/useGrid';

const RelatedPeople = props => {
  const {
    user,
    actions: { connect },
  } = props;

  const {
    data: { isFetching: isGridFetching, rows, rowsCount },
    actions,
  } = useGrid(ENDPOINT.COLLECTION.PEOPLE_YMK, null, false);

  const [isFetching, setFetching] = useState();

  useEffect(() => {
    actions.fetch({ type: 'sidebar' });
  }, []);

  useEffect(() => {
    setFetching(isGridFetching);
  }, [isGridFetching]);

  const onConnectionClickHandler = ({ CandidateID: id }) => {
    setFetching(true);
    connect({ id })
      .then(() => {
        actions.fetch();
      })
      .finally(() => setFetching(false));
  };

  return Number(rowsCount) > 0 ? (
    <div className="related-people-block">
      {isFetching && <LoadMask relative />}
      <h3 className="related-people-block__title">People You May Know</h3>
      <div className="related-people-block__list">
        {rows.map(person => (
          <div
            className="related-people-block__person"
            key={person.CandidateID}
          >
            <div className="related-people-block__person-visual">
              <Avatar
                size={55}
                name={person.FullName}
                image={person.PictureUrl}
              />
              <button
                className="related-people-block__person-button"
                onClick={() => onConnectionClickHandler(person)}
              >
                <FontAwesomeIcon icon={faPlus} color="#fff" size="xs" />
              </button>
            </div>
            <div className="related-people-block__person-content">
              <LinkCandidateProfile
                user={user}
                name={person.FullName}
                cls="related-people-block__person-name"
                id={person.CandidateID}
                viewProfile={person.ViewProfile === 'Yes'}
              />

              {person.FirmName ? (
                person.FirmActive === 'Yes' ? (
                  <NavLink
                    to={LinkBuilder.getFirmLink(person.FirmUrlAlias)}
                    className="related-people-block__person-link"
                  >
                    {person.FirmName}
                  </NavLink>
                ) : (
                  <span className="related-people-block__person-place">
                    {person.FirmName}
                  </span>
                )
              ) : (
                <span className="related-people-block__person-place">
                  {person.currentSchoolName}
                </span>
              )}

              {person.SchoolName && (
                <span className="related-people-block__person-place">
                  {person.SchoolName}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
      <NavLink
        to={ROUTE.PEOPLE_YOU_MAY_KNOW}
        className="related-people-block__view-more"
      >
        View More
      </NavLink>
    </div>
  ) : null;
};

export default RelatedPeople;
